import { createContext, useContext, useRef } from 'react';
import { PlayerRef } from '@remotion/player';

const PlayerContext = createContext<React.RefObject<PlayerRef> | null>(null);

export const usePlayer = () => {
  const context = useContext(PlayerContext);
  if (!context) {
    throw new Error('usePlayer must be used within a PlayerProvider');
  }
  return context;
};

export const PlayerProvider = ({ children }: { children: React.ReactNode }) => {
  const playerRef = useRef<PlayerRef>(null);
  return (
    <PlayerContext.Provider value={playerRef}>
      {children}
    </PlayerContext.Provider>
  );
}; 